var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M19.637 11.312l-2.474 2.463a3.55 3.55 0 01-.577.493c-.907.657-1.897.985-2.969.985a4.926 4.926 0 01-3.958-1.97c-.247-.329-.165-.903.165-1.15.33-.246.907-.164 1.155.165 1.072 1.477 3.133 1.724 4.617.656a.642.642 0 00.33-.328l2.474-2.463c1.237-1.314 1.237-3.366-.083-4.597a3.348 3.348 0 00-4.617 0L12.298 6.96a.8.8 0 01-1.154 0 .791.791 0 010-1.15l1.401-1.395a4.843 4.843 0 016.844 0c2.062 1.806 2.144 5.008.248 6.896zm-8.081 5.665l-1.402 1.396a3.348 3.348 0 01-4.618 0c-1.32-1.232-1.32-3.366-.082-4.598l2.474-2.463.33-.328c.742-.493 1.566-.739 2.473-.657.907.164 1.65.575 2.144 1.314.248.328.825.41 1.155.164.33-.246.412-.821.165-1.15-.825-1.067-1.98-1.723-3.216-1.888-1.237-.246-2.557.082-3.629.903l-.494.493-2.474 2.463c-1.897 1.97-1.814 5.09.082 6.978.99.903 2.227 1.396 3.464 1.396s2.473-.493 3.463-1.396l1.402-1.395a.791.791 0 000-1.15c-.33-.328-.907-.41-1.237-.082z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.21f0df151c4bc441e7ac9dffaabb4354.svg";
export { ForwardRef as ReactComponent };